import { render } from "./douyinaccount.vue?vue&type=template&id=8f7f82fa&scoped=true"
import script from "./douyinaccount.vue?vue&type=script&lang=js"
export * from "./douyinaccount.vue?vue&type=script&lang=js"

import "./douyinaccount.vue?vue&type=style&index=0&id=8f7f82fa&lang=scss&scoped=true"

import exportComponent from "/Users/tangyinbo/workspace/front/syb/syb_webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f7f82fa"]])

export default __exports__